import Vue from "vue";
import Vuex from "vuex";
import decode from "jwt-decode";
import router from "../router";
import axios from "axios";

Vue.use(Vuex);

var store = new Vuex.Store({
  state: {
    token: null,
    usuario: null,
    acciones: null
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUsuario(state, usuario) {
      state.usuario = usuario;
    },
    setAcciones(state, acciones) {
      state.acciones = acciones;
    }
  },
  actions: {
    guardarToken({ commit }, token) {
      localStorage.setItem("token", token);
      commit("setToken", token);
      commit("setUsuario", decode(token));
    },
    async autoLogin({ commit }) {
      let token = localStorage.getItem("token");
      if (token) {
        commit("setToken", token);
        commit("setUsuario", decode(token));
        if (this.state.usuario.rol == "Coordinador Cabina") {
          let turnoActivo = false;

          let header = { Authorization: "Bearer " + this.state.token };
          let configuracion = { headers: header };

          await axios
            .get(`api/HistorialOperadoresCabina/${this.state.usuario.idUsuario}/Activo`, configuracion)
            .then(res => turnoActivo = true)
            .catch(err => console.error(err))

          if (!turnoActivo) {
            router.push({ name: "login", query: { auto: true } }).catch(() => { });
          }
        }

        if (this.state.usuario.rol == "Operador Grua") {
          router.push({ name: "AsignarGrua" }).catch((err) => { });
        }
        //router.push({ name: "novedades" }).catch(() => {});
      } else {
        router.push({ name: "login" }).catch(() => { });
      }
    },
    async salir({ commit }) {
      if (this.state.usuario) {
        let header = { Authorization: "Bearer " + this.state.token };
        let configuracion = { headers: header };

        if (this.state.usuario.rol == "Coordinador Cabina") {
          await axios
            .put(
              `api/HistorialOperadoresCabina/${this.state.usuario.idUsuario}`,
              {},
              configuracion
            )
            .then(() => { })
            .catch(err => console.error(err))
        }

        if (this.state.usuario.rol == "Inspector") {
          await axios
            .put(
              `api/HistorialInspectores/${this.state.usuario.idUsuario}`,
              {},
              configuracion
            )
            .then(() => { })
            .catch(err => console.error(err))
        }
      }

      commit("setToken", null);
      commit("setUsuario", null);
      localStorage.removeItem("token");
      router.push({ name: "login" }).catch(() => { });
    },
    guardarAcciones({ commit }, acciones) {
      commit("setAcciones", acciones);
    }
  },
});

export default store;